import { Divider } from "@heroui/react";
import { useNavigate } from "react-router-dom";

const Footer = () => {

	const navigate = useNavigate();

	return (
		<div className="flex h-10 max-w justify-left items-center px-2 py-1.5 bg-msi-darkgrey-color text-white space-x-4 text-medium">
			<a className="footer-navigate-link text-xs text-center md:text-medium" onClick={(e) => { e.preventDefault(); window.location.href = window.config.MAIN_WEBSITE_URL }} >
				Maritime Strategies International
			</a>
			<Divider orientation="vertical" className="bg-white" />
			<a className="footer-navigate-link text-xs text-center md:text-medium" onClick={(e) => { e.preventDefault(); navigate('/privacy-policy') }} >
				Privacy and Cookies Policy
			</a>
			<Divider orientation="vertical" className="bg-white space-y-2" />
			<a className="footer-navigate-link text-xs text-center md:text-medium" onClick={(e) => { e.preventDefault(); navigate('/terms-conditions') }} >
				Terms and Conditions
			</a>
			<Divider orientation="vertical" className="bg-white" />
			<span className="text-xs text-center md:text-medium">&nbsp;&copy; 2019-{new Date().getFullYear()} </span>

		</div>

	);
}
export default Footer;